import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';

const fmt = d => d ? new Date(d).toLocaleString() : '—';

export default function Recycle() {
  const [d, setD] = useState({ tasks: [], assets: [], containers: [] });
  const [tab, setTab] = useState('tasks');
  const [msg, setMsg] = useState('');
  const load = useCallback(() => api.get('/recycle').then(r => setD(r.data)).catch(()=>{}), []);
  useEffect(() => { load(); }, [load]);
  const flash = m => { setMsg(m); setTimeout(()=>setMsg(''), 2500); };
  const restore = async (kind, id, label) => {
    if (!window.confirm(`Restore ${label}?`)) return;
    try { await api.post(`/recycle/${kind}/${id}/restore`); flash('✓ Restored'); load(); }
    catch (e) { flash(e.response?.data?.error || 'Restore failed'); }
  };

  return (
    <div>
      <div style={{ marginBottom:16 }}>
        <h2 style={{ fontSize:18, fontWeight:600, marginBottom:4 }}>🗑 Recycle Bin</h2>
        <p style={{ fontSize:13, color:'var(--text2)' }}>Soft-deleted tasks, assets, projects &amp; meetings. Nothing is permanently removed — restore anything here.</p>
      </div>
      {msg && <div style={{ fontSize:13, marginBottom:10, color: msg.startsWith('✓')?'var(--green)':'var(--red)' }}>{msg}</div>}
      <div className="flex-gap" style={{ gap:8, marginBottom:14 }}>
        {[['tasks',`✓ Tasks (${d.tasks.length})`],['assets',`□ Assets (${d.assets.length})`],
          ['containers',`📁 Projects & Meetings (${(d.containers||[]).length})`]].map(([id,l]) => (
          <button key={id} className={`btn btn-sm ${tab===id?'btn-primary':'btn-secondary'}`} onClick={() => setTab(id)}>{l}</button>
        ))}
      </div>

      {tab === 'tasks' && (
        <div className="card" style={{ padding:0, overflow:'hidden' }}>
          {!d.tasks.length ? <div className="empty-state"><p>No deleted tasks.</p></div> : (
            <div className="table-wrap"><table>
              <thead><tr><th>Task</th><th>Title</th><th>Campus</th><th>Deleted</th><th>By</th><th></th></tr></thead>
              <tbody>{d.tasks.map(t => (
                <tr key={t.id}>
                  <td className="mono" style={{ fontSize:12 }}>{t.task_id}</td>
                  <td style={{ fontSize:13 }}>{t.title}</td>
                  <td style={{ fontSize:12 }}>{t.campus_name || '—'}</td>
                  <td style={{ fontSize:12, color:'var(--text2)', whiteSpace:'nowrap' }}>{fmt(t.deleted_at)}</td>
                  <td style={{ fontSize:12 }}>{t.deleted_by_name || '—'}</td>
                  <td><button className="btn btn-primary btn-sm" onClick={() => restore('tasks', t.id, t.task_id)}>Restore</button></td>
                </tr>
              ))}</tbody>
            </table></div>
          )}
        </div>
      )}

      {tab === 'assets' && (
        <div className="card" style={{ padding:0, overflow:'hidden' }}>
          {!d.assets.length ? <div className="empty-state"><p>No deleted assets.</p></div> : (
            <div className="table-wrap"><table>
              <thead><tr><th>Asset</th><th>Item</th><th>Campus</th><th>Deleted</th><th>By</th><th></th></tr></thead>
              <tbody>{d.assets.map(a => (
                <tr key={a.id}>
                  <td className="mono" style={{ fontSize:12 }}>{a.asset_tag}</td>
                  <td style={{ fontSize:13 }}>{[a.brand, a.model].filter(Boolean).join(' ') || a.asset_type || '—'}</td>
                  <td style={{ fontSize:12 }}>{a.campus_name || '—'}</td>
                  <td style={{ fontSize:12, color:'var(--text2)', whiteSpace:'nowrap' }}>{fmt(a.deleted_at)}</td>
                  <td style={{ fontSize:12 }}>{a.deleted_by_name || '—'}</td>
                  <td><button className="btn btn-primary btn-sm" onClick={() => restore('assets', a.id, a.asset_tag)}>Restore</button></td>
                </tr>
              ))}</tbody>
            </table></div>
          )}
        </div>
      )}

      {tab === 'containers' && (
        <div className="card" style={{ padding:0, overflow:'hidden' }}>
          {!(d.containers || []).length ? <div className="empty-state"><p>No deleted projects or meetings.</p></div> : (
            <div className="table-wrap"><table>
              <thead><tr><th>Title</th><th>Type</th><th style={{ textAlign:'center' }}>Steps</th>
                <th style={{ textAlign:'center' }}>Tasks</th><th>Deleted</th><th>By</th><th></th></tr></thead>
              <tbody>{d.containers.map(c => (
                <tr key={c.id}>
                  <td style={{ fontWeight:600 }}>
                    {c.title}
                    {c.project_code && <div className="mono" style={{ fontSize:11, color:'var(--text2)' }}>{c.project_code}</div>}
                  </td>
                  <td style={{ fontSize:12 }}>
                    {c.type === 'project' ? 'Project'
                      : c.meeting_kind === 'it_lead' ? 'IT Lead Meeting' : 'IT Head Meeting'}
                  </td>
                  <td style={{ textAlign:'center', fontSize:12 }}>{c.steps}</td>
                  <td style={{ textAlign:'center', fontSize:12 }}>{c.tasks}</td>
                  <td style={{ fontSize:12, color:'var(--text2)', whiteSpace:'nowrap' }}>{fmt(c.deleted_at)}</td>
                  <td style={{ fontSize:12 }}>{c.deleted_by_name || '—'}</td>
                  <td><button className="btn btn-primary btn-sm"
                    onClick={() => restore('containers', c.id, `"${c.title}" and its ${c.tasks} task(s)`)}>Restore</button></td>
                </tr>
              ))}</tbody>
            </table></div>
          )}
        </div>
      )}
    </div>
  );
}
